var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-manage" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "岗位编码", prop: "jobId" } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.queryCondition.jobId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryCondition, "jobId", $$v)
                                  },
                                  expression: "queryCondition.jobId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 1, md: 12, lg: 8, xl: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "岗位名称", prop: "jobName" } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.queryCondition.jobName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryCondition, "jobName", $$v)
                                  },
                                  expression: "queryCondition.jobName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "center" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.restQueryForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                [_vm._v("新增")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onDel } },
                [_vm._v("删除")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "highlight-current-row": "",
                "max-height": "450",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  fixed: "",
                  prop: "jobType",
                  label: "岗位类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("ic")(
                              scope.row.jobType,
                              "TM_USER_JOB",
                              "JOB_TYPE"
                            )
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  fixed: "",
                  prop: "jobId",
                  label: "岗位编码",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  fixed: "",
                  prop: "jobName",
                  label: "岗位名称",
                },
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("common.operation") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editUserInfo(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            nativeOn: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.userRoleEdit(scope.row.tmUserJobId)
                              },
                            },
                          },
                          [_vm._v("添加角色")]
                        ),
                        scope.row.jobType == "SUP"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                nativeOn: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.setDataPermission(scope.row)
                                  },
                                },
                              },
                              [_vm._v("数据权限")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "userInfo_dialog",
          attrs: {
            title: "岗位信息",
            visible: _vm.isAddDialog,
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isAddDialog = $event
            },
            closed: _vm.onCancel,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "postForm",
              attrs: {
                model: _vm.postForm,
                rules: _vm.postRules,
                "label-position": _vm.labelPosition,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "岗位类型", prop: "jobType" } },
                [
                  _c("ic-select", {
                    staticStyle: { width: "100%" },
                    attrs: { table: "TM_USER_JOB", field: "JOB_TYPE" },
                    model: {
                      value: _vm.postForm.jobType,
                      callback: function ($$v) {
                        _vm.$set(_vm.postForm, "jobType", $$v)
                      },
                      expression: "postForm.jobType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "岗位编码", prop: "jobId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.postForm.jobId,
                      callback: function ($$v) {
                        _vm.$set(_vm.postForm, "jobId", $$v)
                      },
                      expression: "postForm.jobId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "岗位名称", prop: "jobName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.postForm.jobName,
                      callback: function ($$v) {
                        _vm.$set(_vm.postForm, "jobName", $$v)
                      },
                      expression: "postForm.jobName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "5px" },
                  attrs: { type: "flex", justify: "center" },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                    [_vm._v("保存")]
                  ),
                  _c("el-button", { on: { click: _vm.onCancel } }, [
                    _vm._v("关闭"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("sys.userList.roleSelection"),
            visible: _vm.showUserRole,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showUserRole = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c("el-transfer", {
                staticStyle: { "text-align": "left", display: "inline-block" },
                attrs: {
                  filterable: "",
                  data: _vm.notSelRoles,
                  titles: [
                    _vm.$t("sys.userList.roleSource"),
                    _vm.$t("sys.userList.roleTarget"),
                  ],
                },
                model: {
                  value: _vm.selRoles,
                  callback: function ($$v) {
                    _vm.selRoles = $$v
                  },
                  expression: "selRoles",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onCancel1 } },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveUserRole } },
                [_vm._v(_vm._s(_vm.$t("common.save")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "数据权限",
            visible: _vm.dataPermissionDialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dataPermissionDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "userInfoForm", attrs: { model: _vm.userInfo } },
            [
              _c("div", { staticClass: "title_box" }, [
                _c("p", { staticClass: "line" }),
                _c("p", { staticClass: "title" }, [_vm._v("数据权限")]),
              ]),
              _c(
                "div",
                { staticClass: "user_info" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c("el-col", [
                        _c("table", { staticClass: "user_table" }, [
                          _c("tr", [
                            _c("td", { staticClass: "title" }, [
                              _vm._v("模块"),
                            ]),
                            _c("td", { staticClass: "title" }, [
                              _vm._v("权限值"),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v("HGS供应商、RMC采购量")]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "0",
                                      prop: "defaultDataScope",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        table: "TM_USER",
                                        field: "DATA_SCOPE",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.userInfo.defaultDataScope,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userInfo,
                                            "defaultDataScope",
                                            $$v
                                          )
                                        },
                                        expression: "userInfo.defaultDataScope",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v("StoreFeedBack")]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "0",
                                      prop: "feedbackDataScope",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        table: "TM_USER",
                                        field: "DATA_SCOPE_TYPE_FEEDBACK",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.userInfo.feedbackDataScope,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userInfo,
                                            "feedbackDataScope",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "userInfo.feedbackDataScope",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v("Sensory")]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "0",
                                      prop: "sensoryDataScope",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        table: "TM_USER",
                                        field: "DATA_SCOPE_TYPE_SENSORY",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.userInfo.sensoryDataScope,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userInfo,
                                            "sensoryDataScope",
                                            $$v
                                          )
                                        },
                                        expression: "userInfo.sensoryDataScope",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("td", [_vm._v("Nutrition")]),
                            _c(
                              "td",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      "label-width": "0",
                                      prop: "nutritionDataScope",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        table: "TM_USER",
                                        field: "NUTRITION_DATA_SCOPE",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.userInfo.nutritionDataScope,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userInfo,
                                            "nutritionDataScope",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "userInfo.nutritionDataScope",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "center" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSavePermission },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onCancelPermission },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }